import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_right",
  "use": "arrow_right-usage",
  "viewBox": "0 0 16.03 11.03",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 16.03 11.03\" id=\"arrow_right\"><path d=\"M10.774.165a.573.573 0 0 0-.806 0 .548.548 0 0 0 0 .781l4.088 3.999H.564a.556.556 0 1 0 0 1.113h13.492l-4.088 3.993a.556.556 0 0 0 0 .788.573.573 0 0 0 .806 0l5.057-4.946a.536.536 0 0 0 0-.781L10.774.165Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol